// extracted by css-extract-rspack-plugin
export default {"resizeBox":"resize-box_kueRo","resizableContainer":"resizable-container_Tfd_3","resizableLine":"resizable-line_lxLTp"};